<template>
  <div style="height: 450px">
    <div class="dinwdw">
      <div class="name_boxr">来源广告主(可选)：</div>
      <div style="display: flex">
        <div>
          <el-button
            type="primary"
            size="mini"
            @click="chooseoperatetwo(1)"
          >选择</el-button>
          <div>
            <el-button
              v-show="query.source_sub_uc_id.length !== 0"
              type="warning"
              size="mini"
              @click="query.source_sub_uc_id = []"
            >清空</el-button>
          </div>
        </div>
        <div style="max-height: 200px; overflow-y: scroll; position: relative">
          <el-tag
            v-for="(itemrse,index) in query.source_sub_uc_id"
            :key="index"
            style="margin-right: 10px; margin-bottom: 5px"
            closable
            :type="'success'"
            @close="rightclicktwo(itemrse)"
          >
            {{ itemrse.sub_uc_name }}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="dinwdw">
      <div class="name_boxr">目标广告主(可选)：</div>
      <div style="display: flex">
        <div>
          <el-button
            type="primary"
            size="mini"
            @click="chooseoperatetwo(2)"
          >选择</el-button>
          <div>
            <el-button
              v-show="query.to_sub_uc_id.length !== 0"
              type="warning"
              size="mini"
              @click="query.to_sub_uc_id = []"
            >清空</el-button>
          </div>
        </div>
        <div style="max-height: 200px; overflow-y: scroll; position: relative">
          <el-tag
            v-for="(itemrse,index) in query.to_sub_uc_id"
            :key="index"
            style="margin-right: 10px; margin-bottom: 5px"
            closable
            :type="'success'"
            @close="rightclicktwoGroup(itemrse)"
          >
            {{ itemrse.sub_uc_name }}
          </el-tag>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogAdmin_id"
      width="800px"
      append-to-body
      :destroy-on-close="true"
    >
      <sub-account ref="account" :type="type" :selecteds="account_selectds" @commit="addElTag" @close="dialogAdmin_id = false" />
    </el-dialog>
    <div style="float: right; margin-top: 20px">
      <el-button type="primary" size="mini" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
import SubAccount from '@/views/baiduAD/components/subAccount.vue'
import { copyJobStop } from '@/api/baiduAD'

export default {
  components: { SubAccount },
  data() {
    return {
      dialogAccountIds: false,
      dialogAdmin_id: false,
      query: {
        name: '',
        source_sub_uc_id: [],
        to_sub_uc_id: []
      },
      admin: {},
      sourceAdmin: {},
      title: '',
      account_selectds: [],
      type: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    submit() {
      if (!this.query.name.length > 0) {
        this.$message.error('当前token数据丢失,请刷新当前页面')
        return
      }
      const obj = {
        name: this.query.name
      }
      if (!this.query.source_sub_uc_id.length && !this.query.to_sub_uc_id.length) {
        this.$message.error('请至少选择一个主账户id或子账户id')
        return
      }
      if (this.query.source_sub_uc_id.length !== 0) {
        obj.source_sub_uc_id = this.query.source_sub_uc_id.map(
          (v) => v.sub_uc_id
        )
      }
      if (this.query.to_sub_uc_id.length !== 0) {
        obj.to_sub_uc_id = this.query.to_sub_uc_id.map((v) => v.sub_uc_id)
      }
      copyJobStop({ obj }).then(res => {
        this.$message.info(res.message)
      })
      this.query = {
        source_sub_uc_id: [],
        to_sub_uc_id: []
      }
    },
    sendr(item) {
      this.query.name = localStorage.getItem('Larke-Admin-Token')
      if (item !== undefined) {
        this.query = item
      }
    },
    rightclicktwo(item) {
      this.query.source_sub_uc_id = this.query.source_sub_uc_id.filter(row => row.id !== item.id)
    },
    rightclicktwoGroup(item) {
      console.log(item)
      this.query.to_sub_uc_id = this.query.to_sub_uc_id.filter(row => row.id !== item.id)
    },
    chooseoperatetwo(type) {
      this.type = type
      this.account_selectds.length = 0
      if (type === 1) {
        this.title = '选择来源广告主'
        this.account_selectds = [...this.account_selectds, ...this.query.source_sub_uc_id]
      } else {
        this.title = '选择目标广告主'
        this.account_selectds = [...this.account_selectds, ...this.query.to_sub_uc_id]
      }
      this.dialogAdmin_id = true
    },
    addElTag(val, type) {
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        this.query.source_sub_uc_id = [...this.query.source_sub_uc_id, ...val]
      } else {
        this.query.to_sub_uc_id = [...this.query.to_sub_uc_id, ...val]
      }
      this.dialogAdmin_id = false
    }
  }
}
</script>

<style scoped>
/* @import url(); 引入css类 */
.dinwdw {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.name_boxr {
  color: rgb(169, 162, 151);
  font-size: 14px;
  width: 140px;
  text-align: right;
  flex-shrink: 0;
}
</style>
